import { createSelector } from 'reselect'
import getSubtotalCartDiscountTrackerDeliverySelect from 'pages/Cart/components/CartDiscountTracker/selectors/get-subtotal'
import hasReachedCheckoutMinimumCartSelectUtil from 'modules/cart/redux/selectors/has-reached-checkout-minimum/utils'

const hasReachedCheckoutMinimumCartSelect = createSelector(
  getSubtotalCartDiscountTrackerDeliverySelect,
  (
    subtotal
  ) => hasReachedCheckoutMinimumCartSelectUtil({
    subtotal
  })
)

export default hasReachedCheckoutMinimumCartSelect
